/* eslint-disable */
export const user = {
    id: 'cfaad35d-07a3-4447-a6c3-d8c3d54fd5df',
    name: 'Fernando Tapia',
    email: 'hola@taxsat.com',
    avatar: '',
    status: 'online',
    rol: 100,
    phone: '',
    statusBack: 0
};
